/* eslint-disable import/prefer-default-export */
import { pickBy } from 'lodash';

const cleanObjectFromUndefined = (
  originalObject,
) => pickBy(originalObject, (v) => v !== undefined && v !== 'undefined' && v !== null && v !== 'null');

export { cleanObjectFromUndefined };
